<template>
    <v-card ref="residenceAssistantManagementCard">
        <v-card-title>
            Residence Assistant Management
            <v-spacer></v-spacer>
            <residence-assistant-manager-add-user :buildings="buildings" @refreshData="refreshData"
                @setNotification="setNotification">
            </residence-assistant-manager-add-user>
        </v-card-title>
        <v-card-text>
            <residence-assistant-manager-data :buildings="buildings" :data="data" @refreshData="refreshData"
                @setNotification="setNotification">
            </residence-assistant-manager-data>
        </v-card-text>
    </v-card>
</template>

<script>
import ResidenceAssistantManagerAddUser from '../../Admin/ResidenceAssistantManager/AddUser';
import ResidenceAssistantManagerData from '../../Admin/ResidenceAssistantManager/ManagerData';

export default {
    name: 'residence-assistant-management',
    props: {
        buildings: {
            required: true,
            type: Array
        },
        data: {
            required: true,
            type: Array
        }
    },
    components: {
        ResidenceAssistantManagerAddUser,
        ResidenceAssistantManagerData
    },
    methods: {
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    }
}
</script>